var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPreferences(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#0B7D63",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 48.000002,16 H 208 c 17.728,0 32,14.272 32,32 v 160 c 0,17.728 -14.272,32 -32,32 H 48.000002 c -17.728,0 -32,-14.272 -32,-32 V 48 c 0,-17.728 14.272,-32 32,-32 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 64.000006,64.000001 H 79.999993"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 79.999996,-96.000015 a 16,16 0 0 1 -16,16 16,16 0 0 1 -16,-16 16,16 0 0 1 16,-16.000005 16,16 0 0 1 16,16.000005 z",
    transform: "rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 112.00001,64.000353 79.99997,-3.52e-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 191.99998,128 H 176"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 144,159.99997 a 16,16 0 0 1 -16,16 16,16 0 0 1 -16,-16 16,16 0 0 1 16,-16 16,16 0 0 1 16,16 z",
    transform: "matrix(0 1 1 0 0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 143.99998,128.00035 64.000006,128"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 64.000006,192.00001 H 79.999993"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 208,-96.000015 a 16,16 0 0 1 -16,16 16,16 0 0 1 -16,-16 16,16 0 0 1 16,-16.000005 16,16 0 0 1 16,16.000005 z",
    transform: "rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 112.00001,192.00036 79.99997,-3.5e-4"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreferences);
export default __webpack_public_path__ + "static/media/preferences.4dd625ddd2180b6022c3bf401f2bba2a.svg";
export { ForwardRef as ReactComponent };